<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: rawMenu.user.slug }}"
    :showCloseButton="true"
  >
    <div
      class="text-center "
      slot="heading"
    >
      <h1 class=" mb-0">
        <span class="font-weight-bold">Deals</span>
      </h1>
      <p
        class="small mb-0"
        style="font-size:1rem"
        v-if="keyChecked && keyExists"
      >
        Are you sure you want to unsubscribe from {{rawMenu.user.name}}'s Deals, Vouchers & Coupons?
      </p>
      <p
        class="small mb-0"
        style="font-size:1rem"
        v-if="keyChecked && (!keyExists)"
      >
        You are Unsubscribed.
      </p>
    </div>
    <div
      slot="content"
      class="px-3"
    >
      <form
        v-on:submit.prevent="onSubmit"
        v-if="keyChecked && keyExists"
      >

        <button
          type="submit"
          class="btn btn-primary btn-lg btn-block mt-4"
          v-if="!appProcessing && keyExists"
        >
          Unsubscribe
        </button>
        <formLoader
          v-if="appProcessing"
          class="text-center my-5"
        ></formLoader>
        <div
          v-if="!appProcessing"
          class="small text-center mt-3"
        >
        </div>

      </form>
    </div>
  </modal>
</template>

<style scoped>
</style>

<script>
import formLoader from "../../form/FormLoader";
import modal from "../../shared/Modal";
import pageMixin from "../../../mixins/pageMixin";
import formMixin from "../../../mixins/formMixin";
export default {
  mounted() {
    this.$gtag.pageview({
      page_title: this.rawMenu.user.name + "Unsubscribe Deals ",
    });
    if (this.$route.params.key) {
      this.checkKey();
    } else {
      this.keyChecked = true;
      this.keyExists = false;
    }
  },
  data() {
    return {
      success: false,
      keyExists: false,
      keyChecked: false,
    };
  },
  metaInfo() {
    return {
      title: this.rawMenu.user.name + "Unsubscribe Deals",
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content: this.rawMenu.user.name + "Unsubscribe Deals",
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: this.rawMenu.user.name + "Unsubscribe Deals",
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content: this.rawMenu.user.name + "Unsubscribe Deals",
        },
      ],
    };
  },
  methods: {
    checkKey: function () {
      this.setAppProcessing(true);
      axios
        .post("/api/user/subscription/check", {
          user_id: this.rawMenu.user.id,
          key: this.$route.params.key,
        })
        .then(
          (response) => {
            this.setAppProcessing(false);
            this.keyChecked = true;
            this.keyExists = true;
          },
          (error) => {
            this.keyChecked = true;
            this.keyExists = false;
          }
        );
    },
    onSubmit: function () {
      this.setAppProcessing(true);
      this.errors = {};
      axios
        .post("/api/user/unsubscribe", {
          user_id: this.rawMenu.user.id,
          key: this.$route.params.key,
        })
        .then(
          (response) => {
            this.setAppProcessing(false);
            this.keyExists = false;
          },
          (error) => {
            this.keyExists = false;
          }
        );
    },
  },
  components: {
    formLoader,
    modal,
  },
  mixins: [pageMixin, formMixin],
};
</script>
